import type { UnanalyzedGame } from "./analysis.api";
import { normalizeExactTimeControl } from "@chessla/shared";
import type { ChessComImportFilters } from "../games/games.api";

export const analysisClockPresets: Record<string, string[]> = {
  rapid: ["600", "900", "900+10", "1800"],
  blitz: ["180", "180+2", "300", "300+5"],
  bullet: ["60", "60+1", "120+1"],
  daily: ["1/86400", "1/259200", "1/604800"],
};

export const analysisImportFilters = (format: string, clock: string): ChessComImportFilters =>
  format === "all"
    ? {}
    : {
        timeControl: format,
        ...(clock === "all" ? {} : { exactTimeControl: normalizeExactTimeControl(clock) ?? "unknown" }),
      };

export const matchesAnalysisTarget = (
  game: Pick<UnanalyzedGame, "timeControl" | "exactTimeControl">,
  format: string,
  clock: string,
  clockLabel: (exact: string | null, format: string) => string,
) =>
  format === "all" ||
  (game.timeControl === format && (clock === "all" || clockLabel(game.exactTimeControl, game.timeControl) === clock));
